import { useCallback } from 'react';
import { isEmpty } from 'lodash-es';
import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import {
  getLocalStorageValue,
  LOCAL_STORAGE_KEYS,
  setLocalStorageValue
} from '@namespace/helpers';
import { getABTestWithAdd } from '../../api/getABTestWithAdd';
import { abTestActions } from '../../store';

const { ADD_SEGMENTS_AB_TEST } = abTestActions;

const useSetCustomSegmentABTest = (abTestName) => {
  const deviceId = getLocalStorageValue(LOCAL_STORAGE_KEYS.AB_TEST_DEVICE_ID);
  const { abTestSegments } = useOtherSettings();
  const requiredABTest = abTestSegments?.find(
    ({ name }) => name === abTestName
  );

  return useCallback(async () => {
    if (deviceId && !isEmpty(requiredABTest)) {
      const { data = [] } = await getABTestWithAdd(deviceId, [
        { name: requiredABTest?.name }
      ]);
      if (!isEmpty(data)) {
        ADD_SEGMENTS_AB_TEST(data);
        setLocalStorageValue('currentABTestsGroup', data[0]?.group);

        return data[0]?.group;
      }
    }

    return null;
  }, [deviceId, requiredABTest]);
};

export default useSetCustomSegmentABTest;
